import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type {
  RegistrationCode,
  UpdateRegistrationCodePayload,
} from '../types/registrationCode';
import { inviteCodeQueryKeys, retryInviteCodeMutation } from './useInviteCodes';
import { partnerReferralCodeQueryKeys } from './usePartnerReferralCodes';

export interface UpdateInviteCodeVariables {
  id: string;
  payload: UpdateRegistrationCodePayload;
}

export function useUpdateInviteCode(
  options?: UseMutationOptions<
    RegistrationCode,
    Error,
    UpdateInviteCodeVariables
  >,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['inviteCode', 'update'],
    mutationFn: async ({ id, payload }: UpdateInviteCodeVariables) =>
      service.updateRegistrationCode(id, payload),
    retry: retryInviteCodeMutation,
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: inviteCodeQueryKeys.all });
      // Partner code pages render the linked invite codes' code and promo details.
      queryClient.invalidateQueries({
        queryKey: partnerReferralCodeQueryKeys.all,
      });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
